"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = _interopRequireWildcard(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactTinyVirtualList = _interopRequireDefault(require("react-tiny-virtual-list"));

require("./forumPage.scss");

var _Post = _interopRequireWildcard(require("./Post"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const initialState = {
  selectedPostId: undefined,
  currentPage: 0
};

class PostList extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.renderPostItem = ({
      index,
      style
    }) => {
      const {
        posts
      } = this.props;

      if (!posts || posts && !posts[index]) {
        return /*#__PURE__*/_react.default.createElement("div", null, "Unknown Error");
      }

      const post = posts[index];
      return /*#__PURE__*/_react.default.createElement("div", {
        key: post.id,
        style: style,
        onClick: () => this.props.onSelectPost(post)
      }, /*#__PURE__*/_react.default.createElement(_Post.default, {
        mode: _Post.PostMode.PARTIAL,
        key: post.id,
        post: post
      }));
    };
  }

  render() {
    const {
      posts = [],
      scrollTop,
      selectedPostId
    } = this.props;
    const height = this.props.height ? this.props.height : '100%';

    const selectedPost = _.find(posts, p => p.id === selectedPostId);

    const listItemSize = 220;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-forum-page-tab-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-forum-page-tab-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: "postListLeft",
      className: "postList"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "centerList"
    }, /*#__PURE__*/_react.default.createElement(_reactTinyVirtualList.default, {
      width: "100%",
      style: {
        backgroundColor: 'black'
      },
      height: height,
      itemCount: posts.length,
      itemSize: listItemSize,
      scrollOffset: scrollTop,
      renderItem: this.renderPostItem,
      onScroll: this.props.onScroll
    }))), /*#__PURE__*/_react.default.createElement("div", {
      id: "selectedPostRight",
      className: "postList"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "centerList",
      style: {
        height
      }
    }, selectedPost && /*#__PURE__*/_react.default.createElement(_Post.default, {
      mode: _Post.PostMode.FULL,
      post: selectedPost
    })))));
  }

}

var _default = (0, _reactRedux.connect)(null, null)(PostList);

exports.default = _default;